// Copyright (c) 2026 Query Health Inc. All rights reserved.
// Author: Anmol Rajpal <anmol@quantinohealth.com>
// Licensed under a Commercial License. See LICENSE for terms.

import { Sun, Moon, Menu } from 'lucide-react'
import { LogoWordmark } from '@qh/design-tokens/logos'
import { useTheme } from '@/context/theme-context'

interface TopNavbarProps {
  onMobileMenuClick: () => void
}

export default function TopNavbar({ onMobileMenuClick }: TopNavbarProps) {
  const { theme, toggleTheme } = useTheme()

  return (
    <header className="fixed top-0 left-0 right-0 z-50 h-14 bg-card border-b border-border flex items-center px-4 lg:px-6">
      <button
        onClick={onMobileMenuClick}
        className="lg:hidden mr-3 h-8 w-8 rounded-lg flex items-center justify-center text-muted-foreground hover:text-foreground hover:bg-secondary transition-colors"
        aria-label="Open navigation"
      >
        <Menu className="h-5 w-5" />
      </button>

      <div style={theme === 'dark' ? { filter: 'brightness(0) invert(1)' } : undefined}>
        <LogoWordmark className="h-7 w-auto" aria-hidden />
      </div>

      <div className="flex-1" />

      <button
        onClick={toggleTheme}
        className="h-8 w-8 rounded-lg flex items-center justify-center text-muted-foreground hover:text-foreground hover:bg-secondary transition-colors"
        aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
      >
        {theme === 'dark' ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
      </button>
    </header>
  )
}
